export default __webpack_public_path__ + "static/headerBg-0a08dd172ed146dcfba53a3fff860572.png";